import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../core/services/admin.service';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-customer-specific-school',
  templateUrl: './customer-specific-school.component.html',
  styleUrls: ['./customer-specific-school.component.scss']
})
export class CustomerSpecificSchoolComponent implements OnInit {

  description: string = "";
  pdfUrl: any=null;
  constructor(private adminService: AdminService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const body = {
      trainingType: "CustomerSpecificSchool",
      languageCode: localStorage.getItem("language")
    }
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      if (response.length > 0) {
        if (response[0].description) {
          this.description = response[0].description;
        }
       else if (response[0].urlPath) {
          const url = environment.imageUrl + response[0].urlPath;
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
      }
    })
  }

}
